import { useEffect, useState } from 'react';
import { graphql, useFragment } from 'react-relay';
import { useDibsContracts } from 'dibs-crypto-utils/exports/useDibsContracts';
import { usePersistedWalletAddress } from 'dibs-crypto-utils/exports/usePersistedWalletAddress';

import { useHasMinterRole_viewer$key } from './__generated__/useHasMinterRole_viewer.graphql';

export function useHasMinterRole({
    viewer: viewerRef,
}: {
    viewer: useHasMinterRole_viewer$key | null;
}): boolean | null {
    const viewer = useFragment(
        graphql`
            fragment useHasMinterRole_viewer on Viewer {
                ...usePersistedWalletAddress_viewer @arguments(fetchUser: false, userId: "")
            }
        `,
        viewerRef
    );
    const [contracts] = useDibsContracts();
    const { persistedAddress } = usePersistedWalletAddress({ viewer });
    const [hasMinterRole, setHasMinterRole] = useState<boolean | null>(null);

    useEffect(() => {
        (async () => {
            if (contracts && persistedAddress && contracts.tokenV2) {
                // eslint-disable-next-line new-cap
                const minterRole = await contracts.tokenV2.MINTER_ROLE();
                const userHasMinterRole = await contracts.tokenV2.hasRole(
                    minterRole,
                    persistedAddress
                );
                setHasMinterRole(userHasMinterRole);
            }
        })();
    }, [contracts, persistedAddress]);

    return hasMinterRole;
}
